import React from 'react';
import PageHeader from '../components/PageHeader';
import { useNavigate } from 'react-router-dom';

const Roles = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 1,
      name: 'Super Admin',
      permissions: ['All Permissions'],
      users: 1,
    },
    {
      id: 2,
      name: 'Admin',
      permissions: ['Products', 'Orders', 'Customers', 'Reports'],
      users: 2,
    },
    {
      id: 3,
      name: 'Moderator',
      permissions: ['Products', 'Orders', 'Reviews'],
      users: 3,
    },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Roles & Permissions"
        description="Manage user roles and permissions"
        breadcrumbs={['Home', 'Roles']}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {roles.map(role => (
          <div key={role.id} className="bg-white rounded-xl border border-gray-100 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{role.name}</h3>
            <p className="text-sm text-gray-600 mb-4">{role.users} users</p>
            <div className="mb-4">
              <p className="text-xs font-medium text-gray-700 mb-2">Permissions:</p>
              <div className="space-y-1">
                {role.permissions.map((perm, idx) => (
                  <p key={idx} className="text-xs text-gray-600">• {perm}</p>
                ))}
              </div>
            </div>
            <button className="w-full px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-700 font-medium text-sm">
              Edit Role
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Roles;
